import { Body, H4 } from '@cointracker/ui';
import type { CollectionEntry } from 'astro:content';
import { createSlug } from '../../../common/utils';
import {
  learnEntryContainer,
  learnEntryLink,
  learnEntryTitle,
  learnPageContent,
} from './EntriesSection.css';

interface EntriesSectionProps {
  entries: CollectionEntry<'learn'>[];
}

export const EntriesSection = ({ entries }: EntriesSectionProps) => {
  return (
    <section className={learnPageContent}>
      {entries.map((entry) => (
        <div key={entry.id} className={learnEntryContainer}>
          <a href={`/learn/${createSlug(entry.data.topic)}`}>
            <H4 className={learnEntryTitle}>{entry.data.topic}</H4>
          </a>
          <Body>
            {entry.data.description}{' '}
            <a
              href={`/learn/${createSlug(entry.data.topic)}`}
              className={learnEntryLink}
            >
              See more
            </a>
          </Body>
        </div>
      ))}
    </section>
  );
};
